export default __webpack_public_path__ + "static/media/sql.e503bd2d.png";